// @flow

import type { StoreResourceDef } from 'app/core/types'

export const takeRefMedias: StoreResourceDef<> = {
  resourceType: 'takeRefMedias',
  relations: {
    mediaInst: {
      type: 'hasOne',
      resourceType: 'medias',
      foreignKey: 'media',
    },
  },
}
